// © Microsoft Corporation. All rights reserved.

export enum ExperienceState {
    /**
     * State when experience has not started its lifecycle events
     */
    NotStarted = 0,

    /**
     * This state is when experience is waiting to load its bundles
     */
    WaitingToLoad = 1,

    /**
     * Bundles loaded for experience and connector has been initialized
     */
    LoadedWaitingToRender = 2,

    /**
     * All milestone dependencies have been resolved for this experience and its ready to render
     */
    ReadyToRender = 3,

    /**
     * Experience failed to load
     */
    Failed = 4,

    /**
     * Experience state is not known, probably when timeout happened before dependency is resolved or dependency is on some UI event.
     */
    Unknown = 5
}